import React from 'react';
import { Trans } from '@lingui/macro';

export const tAddPhoneEmailLabel = <Trans>Email</Trans>;
